import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  LinearProgress,
  useTheme,
  Button,
} from "@mui/material";
import FruitifyIcon from "../../../shared-components/FruitifyIcons";
import { alpha } from "@mui/material/styles";

const QuestionExtractionProgress = ({ extractionStatus, onCancel }) => {
  // TODO: replace this with new JobsAccordion
  const { message, progress } = extractionStatus || {};
  const theme = useTheme();

  return (
    <Card
      sx={{
        backgroundColor: alpha(theme.palette.info.light, 0.5),
        mb: 2,
      }}
    >
      <CardContent>
        {/* Top row: icon + title, cancel button */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={1}>
            <FruitifyIcon
              name="Assignment"
              fontSize="medium"
              sx={{ color: theme.palette.text.primary }}
            />
            <Typography variant="body1">Extracting Questions</Typography>
          </Box>
          {onCancel && ( // TODO: implement - for now hide as not providing onCancel
            <Button
              onClick={onCancel}
              variant={"card-action"}
              sx={{ backgroundColor: "transparent" }}
            >
              Cancel
            </Button>
          )}
        </Box>

        {/* Extraction message */}
        {message && (
          <Typography variant="body2" sx={{ mb: 1, ml: 4 }}>
            {message}
          </Typography>
        )}

        {/* Progress bar */}
        <LinearProgress
          variant="determinate"
          value={progress ?? 0}
          sx={{
            height: 8,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.background.paper, 0.3),
          }}
        />
      </CardContent>
    </Card>
  );
};

export { QuestionExtractionProgress };
